// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const SubClaimTypes = t.list(KeyValuePair, 'SubClaimTypes');

export const getDefaultState = () => new SubClaimTypes([]);

export default SubClaimTypes;



// WEBPACK FOOTER //
// ./src/shared/state/sub-claim-types.js